import { Injectable } from '@angular/core';
import { RokezzzAuthorizationService } from './authorization.service';

@Injectable({
    providedIn: 'root'
})
export class RokezzzAclMatcherService {
    public static isLoggedIn(): boolean {
        return RokezzzAuthorizationService.isLoggedIn();
    }

    public static isLoggedOut(): boolean {
        return !RokezzzAuthorizationService.isLoggedIn();
    }

    public static isAdminIn(): boolean {
        return RokezzzAuthorizationService.hasRole(RokezzzAuthorizationService.adminRole);
    }
}
